import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
	before: string | null;
	after: string | null;
}

const CaseFilesChangeLog: React.FC<IProps> = ({ before, after }) => {
	const { t } = useTranslation();

	return (
		<div>
			{before && (
				<div>
					<strong>
						{t('catalog.file.information')} {t('common.added')}:
					</strong>
					{before && <div>{before}</div>}
				</div>
			)}
			{after && (
				<div>
					<strong>
						{t('catalog.file.information')} {t('common.removed')}:
					</strong>
					{after && <div>{after}</div>}
				</div>
			)}
		</div>
	);
};

export default CaseFilesChangeLog;
